import { useNavigate } from "react-router-dom";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import Header from "./header";
import Viewport from "./viewport";
import styles from "./app-layout.module.css";
import "@justworkshr/milo-components/dist/baseCSS.css";

const referrer = document.referrer;
const urlParams = new URLSearchParams(window.location.search);
const isGhost = urlParams.get("ghost") === "true";
const isWorkforce =
  (referrer &&
    (referrer.includes("workforce") || referrer.includes("read-only"))) ||
  isGhost;

const oktaAuth = new OktaAuth({
  issuer: isWorkforce
    ? process.env.REACT_APP_OKTA_WORKFORCE_ISSUER || ""
    : process.env.REACT_APP_OKTA_CIAM_ISSUER || "",
  clientId: isWorkforce
    ? process.env.REACT_APP_OKTA_WORKFORCE_CLIENT_ID || ""
    : process.env.REACT_APP_OKTA_CIAM_CLIENT_ID || "",
  redirectUri: isWorkforce
    ? window.location.origin +
        process.env.REACT_APP_OKTA_WORKFORCE_LOGIN_CALLBACK || ""
    : window.location.origin + process.env.REACT_APP_OKTA_CIAM_LOGIN_CALLBACK ||
      "",
});

const AppLayout = () => {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  window.addEventListener("message", (event) => {
    if (
      event?.data?.event === "forethoughtWidgetLoaded" &&
      window?.innerWidth < 480 &&
      window?.Forethought
    ) {
      window.Forethought("widget", "hide");
    }
  });

  return (
    <div className={styles.appLayout}>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <section className={styles.header}>
          <Header />
        </section>
        <section className={styles.viewport}>
          <Viewport />
        </section>
      </Security>
    </div>
  );
};

export default AppLayout;
